import { ContractTargetType, Option } from "tm-shared/types";

export const CONTRACTS_VOCABULARY = {
    paidProductInput: "Платне введення товару",
    shelfPayment: "Оплачений поличний простір",
    additionalSalesPlace: "Додаткове місце продажу",
    marketingCatalog: "Маркетинг каталог",
};

export const CONTRACT_TARGET_TYPES_OPTIONS: Option<ContractTargetType>[] = [
    {
        label: "ТТ",
        value: ContractTargetType.Market,
    },
    {
        label: "Мережа",
        value: ContractTargetType.Network,
    },
    {
        label: "Контрагент",
        value: ContractTargetType.Contragent,
    },
    {
        label: "Склад",
        value: ContractTargetType.Storage,
    },
    {
        label: "Область",
        value: ContractTargetType.MainRegion,
    },
];
